import { render, staticRenderFns } from "./ExtractItem.vue?vue&type=template&id=6a510064&"
import script from "./ExtractItem.vue?vue&type=script&lang=ts&"
export * from "./ExtractItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports